import * as React from "react";
import Card from 'react-bootstrap/Card';
import {Quotation} from "components/models/Quotation";
import Table from "react-bootstrap/Table";

interface Props {
  quotation: Quotation;
}

export default class extends React.Component<Props> {

  render() {
    const q = this.props.quotation;
    return <>
      <Card className="mb-4">
        <Card.Header>
          Details
        </Card.Header>
        <Card.Body className="p-2">
          <Table borderless size={"sm"}>
            <tbody>
            <tr>
              <td className="text-dark w150px">Created</td>
              <td>{q.created_at.format("Do MMMM YYYY")}</td>
            </tr>
            <tr>
              <td className="text-dark w150px">Updated</td>
              <td>{q.updated_at.format("Do MMMM YYYY")}</td>
            </tr>
            </tbody>
          </Table>
          <hr/>
          <Table borderless size={"sm"}>
            <tbody>
            <tr>
              <td className="text-dark w150px">Allocated To</td>
              <td>{ q.allocated_to?.full_name }</td>
            </tr>
            <tr>
              <td className="text-dark w150px">Number</td>
              <td>{ q.number }</td>
            </tr>
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </>
  }
}